/**
 * Die Reiter der Verwaltung (`/admin?tab=`), als Namen fuer die URL. Eigene Datei, weil
 * `app.config.ts` (Benutzerverwaltungs-Pfad), Startseite, Assistent und Kalkulationskarten
 * hierher verlinken, ohne die Seite in ihren Chunk zu ziehen. Die Reihenfolge ist die Anzeigereihenfolge
 * und muss zu `admin-page.component.html` passen.
 */
export const ADMIN_REITER = {
  PRODUKTKATALOG: 'produktkatalog',
  BENUTZER: 'benutzer',
  VERTRAEGE: 'vertraege',
} as const
export type AdminReiter = (typeof ADMIN_REITER)[keyof typeof ADMIN_REITER]

/**
 * Query-Parameter, mit dem der Reiter „Verträge" gleich das Sheet „Vertrag hinzufügen" öffnet
 * (`/admin?tab=vertraege&hinzufuegen=1`, Tipp auf der Startseite). Die Seite nimmt ihn danach aus der
 * URL, damit Neuladen und Zurück das Sheet nicht wieder aufreißen.
 */
export const VERTRAG_HINZUFUEGEN_PARAM = 'hinzufuegen'

/**
 * Query-Parameter, mit dem der Produktkatalog gleich „Preisliste vom Lieferanten einlesen" oeffnet
 * (`/admin?tab=produktkatalog&ohneEk=1&lieferantenliste=1`, Tipp „Einkaufspreise" auf der Startseite).
 * Die Seite nimmt ihn danach aus der URL, damit Neuladen und Zurueck den Dialog nicht wieder oeffnen.
 */
export const LIEFERANTENLISTE_PARAM = 'lieferantenliste'
